import { live, LiveController } from "@camertron/live-component";

export type Square = {
  x: number;
  y: number;
  letter: string;
}

export type SquareComponentProps = {
  square: Square
  index: number
  active: boolean
  current: boolean
  on_click: (x: number, y: number) => void;
  on_keydown: (key: string) => void;
}

export interface SquareComponent {
  squareTarget: HTMLElement;
}

@live("Crossword::SquareComponent")
export class SquareComponent extends LiveController<SquareComponentProps> {
  static targets = ["square"];

  keydown(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey || event.shiftKey) return;

    this.props.on_keydown(event.key);
  }

  click(_event: MouseEvent) {
    const square = this.props.square;
    this.props.on_click(square.x, square.y);
  }

  override after_update() {
    if (this.props.current) {
      this.squareTarget?.focus();
    }
  }
}
